// Import public-specific styles
import '../styles/public.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import PublicApp from './PublicApp';

// Bootstrap public form submission page
const rootEl = document.getElementById('easyforms-app');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <PublicApp />
    </React.StrictMode>
  );
} else {
  console.error('EasyForms: #easyforms-app mount element not found');
}

